<template>
    <div>
        <app-filepicker
            label="Logo"
            data-source="deha.user.misc.logo"
            accept=".jpg,.png,.gif"
        ></app-filepicker>

        <app-list
            v-if="hasPackageBasic"
            :data-source="'tecpage.user.pages'"
            :data-preset="false"
            :data-name="'name'"
            :list-subpage="'Pages'"
            :allow-individual="true"
            :hide-add-button="Object.values(getPossiblePagesToCreate('header')).length === 0"
            :data-conditions="{ menu_id: this.menuId }"
            :label="'Seite'"
        ></app-list>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import List from '@/components/fields/complex/List.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['hasPackageBasic', 'getPossiblePagesToCreate'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R071'),
            showGlobal: false
        });
    },
    props: {
        menuId: String,
        listitemId: String
    },
    components: {
        'app-list': List,
        'app-filepicker': Filepicker
    }
};
</script>
